import React from "react";

const phrases = [
  "We make it.",
  "You post it.",
  "You grow.",
  "72–96 hours.",
  "Done for you.",
  "No calls. No fluff.",
];

export const Marquee = () => {
  const items = [...phrases, ...phrases, ...phrases];
  return (
    <div
      className="border-y border-[#3B9EFF]/15 bg-[#080C14] overflow-hidden py-5"
      data-testid="brand-marquee"
    >
      <div className="marquee-track gap-12">
        {items.map((p, i) => (
          <div key={i} className="flex items-center gap-12 shrink-0">
            <span className="text-[#3B9EFF] font-display text-2xl md:text-3xl font-bold tracking-tight">
              {p}
            </span>
            <span className="w-2 h-2 bg-[#3B9EFF] rotate-45 inline-block" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
